<script>
import { connect } from 'vuex-connect';
import ThanksBox from '../scenes/ThanksBox.vue';

export default connect({
  gettersToProps: {
    organization: 'stationOrganization',
    hasExpired: 'hasExpired',
    hasCalledHelp: 'hasCalledHelp',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.getStation,
  },
  lifecycle: {
    created ({ dispatch }) {
      // dispatch('getStation')
    },
  },
})('ThanksBox', ThanksBox);
</script>
